// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file guest/v1/shop.proto (package guest.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file guest/v1/shop.proto.
 */
export const file_guest_v1_shop: GenFile = /*@__PURE__*/
  fileDesc("ChNndWVzdC92MS9zaG9wLnByb3RvEghndWVzdC52MSI+ChRHZXRTaG9wRGV0YWlsUmVxdWVzdBIPCgdzaG9wX2lkGAEgASgDEhUKDWxhbmd1YWdlX2NvZGUYAiABKAkicgoVR2V0U2hvcERldGFpbFJlc3BvbnNlEiIKBHNob3AYASABKAsyFC5ndWVzdC52MS5TaG9wRGV0YWlsEicKCHByb2R1Y3RzGAIgAygLMhUuZ3Vlc3QudjEuU2hvcFByb2R1Y3QSDAoEbm90ZRgDIAEoCSKqAgoKU2hvcERldGFpbBIPCgdzaG9wX2lkGAEgASgDEhUKDWxhbmd1YWdlX2NvZGUYAiABKAkSDAoEbmFtZRgDIAEoCRITCgtwb3N0YWxfY29kZRgEIAEoCRIPCgdhZGRyZXNzGAUgASgJEg4KBmFjY2VzcxgGIAEoCRIUCgxwaG9uZV9udW1iZXIYByABKAkSFQoNYnVzaW5lc3NfaG91chgIIAEoCRIbChNyZWd1bGFyX2Nsb3NpbmdfZGF5GAkgASgJEhAKCHNob3BfdXJsGAogASgJEhMKC2Rlc2NyaXB0aW9uGAsgASgJEhEKCWltYWdlX3VybBgMIAMoCRIVCg1pbWFnZV9jYXB0aW9uGA0gAygJEhUKDW1pY2hlbGluX3N0YXIYDiABKAUihAEKC1Nob3BQcm9kdWN0EhIKCnByb2R1Y3RfaWQYASABKAMSDAoEbmFtZRgCIAEoCRIYChBpbmNsdWRlZF9pbl9jb3N0GAMgASgJEiYKBnByaWNlcxgEIAMoCzIWLmd1ZXN0LnYxLlByb2R1Y3RQcmljZRIRCglpbWFnZV91cmwYBSABKAkiawoMUHJvZHVjdFByaWNlEhUKDXByaWNlX3R5cGVfaWQYASABKAMSDAoEbmFtZRgCIAEoCRISCgpwcmljZV90eXBlGAMgASgJEg0KBXByaWNlGAQgASgDEhMKC2Rlc2NyaXB0aW9uGAUgASgJMl8KC1Nob3BTZXJ2aWNlElAKDUdldFNob3BEZXRhaWwSHi5ndWVzdC52MS5HZXRTaG9wRGV0YWlsUmVxdWVzdBofLmd1ZXN0LnYxLkdldFNob3BEZXRhaWxSZXNwb25zZUJHWkVnaXRodWIuY29tL2ViaXNvbC92aWFqZXJvL2JhY2tlbmQvaW50ZXJuYWwvZ2VuL3Byb3RvL2d1ZXN0L3YxO2d1ZXN0djFiBnByb3RvMw");

/**
 * @generated from message guest.v1.GetShopDetailRequest
 */
export type GetShopDetailRequest = Message<"guest.v1.GetShopDetailRequest"> & {
  /**
   * JapanTicket shopId (read_model.shop.shop_id。必須)。
   *
   * @generated from field: int64 shop_id = 1;
   */
  shopId: bigint;

  /**
   * 表示言語コード (例: ja / en / zh-CN / zh-TW)。該当言語の行が無ければ en へフォールバックする。
   *
   * @generated from field: string language_code = 2;
   */
  languageCode: string;
};

/**
 * Describes the message guest.v1.GetShopDetailRequest.
 * Use `create(GetShopDetailRequestSchema)` to create a new message.
 */
export const GetShopDetailRequestSchema: GenMessage<GetShopDetailRequest> = /*@__PURE__*/
  messageDesc(file_guest_v1_shop, 0);

/**
 * @generated from message guest.v1.GetShopDetailResponse
 */
export type GetShopDetailResponse = Message<"guest.v1.GetShopDetailResponse"> & {
  /**
   * 店舗詳細 (read_model.shop 由来)。
   *
   * @generated from field: guest.v1.ShopDetail shop = 1;
   */
  shop?: ShopDetail | undefined;

  /**
   * 店舗に紐づく商品一覧 (read_model.product 由来)。無ければ空配列。
   *
   * @generated from field: repeated guest.v1.ShopProduct products = 2;
   */
  products: ShopProduct[];

  /**
   * 注意事項 (read_model.product.note 由来)。店舗に紐づく一個目の商品の note を採用する
   * (PoC では一店舗一商品前提。複数あっても note は同一の前提)。商品が無ければ空文字。
   *
   * @generated from field: string note = 3;
   */
  note: string;
};

/**
 * Describes the message guest.v1.GetShopDetailResponse.
 * Use `create(GetShopDetailResponseSchema)` to create a new message.
 */
export const GetShopDetailResponseSchema: GenMessage<GetShopDetailResponse> = /*@__PURE__*/
  messageDesc(file_guest_v1_shop, 1);

/**
 * ShopDetail は店舗詳細 1 件 (read_model.shop の採用言語行由来)。
 * 外部データの任意項目 (NULL あり得る列) は空文字で返す。
 *
 * @generated from message guest.v1.ShopDetail
 */
export type ShopDetail = Message<"guest.v1.ShopDetail"> & {
  /**
   * JapanTicket shopId (言語非依存の安定 ID)。
   *
   * @generated from field: int64 shop_id = 1;
   */
  shopId: bigint;

  /**
   * 採用された言語コード (指定言語 or フォールバック先の en)。
   *
   * @generated from field: string language_code = 2;
   */
  languageCode: string;

  /**
   * 店舗名。
   *
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * 郵便番号。
   *
   * @generated from field: string postal_code = 4;
   */
  postalCode: string;

  /**
   * 住所。
   *
   * @generated from field: string address = 5;
   */
  address: string;

  /**
   * アクセス情報。
   *
   * @generated from field: string access = 6;
   */
  access: string;

  /**
   * 電話番号。
   *
   * @generated from field: string phone_number = 7;
   */
  phoneNumber: string;

  /**
   * 営業時間。
   *
   * @generated from field: string business_hour = 8;
   */
  businessHour: string;

  /**
   * 定休日。
   *
   * @generated from field: string regular_closing_day = 9;
   */
  regularClosingDay: string;

  /**
   * 店舗 URL。
   *
   * @generated from field: string shop_url = 10;
   */
  shopUrl: string;

  /**
   * 店舗説明。
   *
   * @generated from field: string description = 11;
   */
  description: string;

  /**
   * 画像 URL 配列 (順序 = 表示順)。
   *
   * @generated from field: repeated string image_url = 12;
   */
  imageUrl: string[];

  /**
   * 画像キャプション配列 (image_url と同インデックスで対応)。
   *
   * @generated from field: repeated string image_caption = 13;
   */
  imageCaption: string[];

  /**
   * ミシュラン星数 (1-3、ja の description から抽出。0 = なし)。
   *
   * @generated from field: int32 michelin_star = 14;
   */
  michelinStar: number;
};

/**
 * Describes the message guest.v1.ShopDetail.
 * Use `create(ShopDetailSchema)` to create a new message.
 */
export const ShopDetailSchema: GenMessage<ShopDetail> = /*@__PURE__*/
  messageDesc(file_guest_v1_shop, 2);

/**
 * ShopProduct は店舗に紐づく商品 1 件 (read_model.product 由来。ゲスト向け一覧表示用)。
 *
 * @generated from message guest.v1.ShopProduct
 */
export type ShopProduct = Message<"guest.v1.ShopProduct"> & {
  /**
   * JapanTicket productId。
   *
   * @generated from field: int64 product_id = 1;
   */
  productId: bigint;

  /**
   * 商品名。
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * 料金に含まれるもの。
   *
   * @generated from field: string included_in_cost = 3;
   */
  includedInCost: string;

  /**
   * 価格配列 (read_model.product.prices 由来)。
   *
   * @generated from field: repeated guest.v1.ProductPrice prices = 4;
   */
  prices: ProductPrice[];

  /**
   * 代表画像 URL (image_url 配列の先頭。無ければ空文字)。
   *
   * @generated from field: string image_url = 5;
   */
  imageUrl: string;
};

/**
 * Describes the message guest.v1.ShopProduct.
 * Use `create(ShopProductSchema)` to create a new message.
 */
export const ShopProductSchema: GenMessage<ShopProduct> = /*@__PURE__*/
  messageDesc(file_guest_v1_shop, 3);

/**
 * ProductPrice は商品の価格 1 件 (prices JSONB[] の要素構造。Shop・商品データ同期_詳細設計 §4.1)。
 *
 * @generated from message guest.v1.ProductPrice
 */
export type ProductPrice = Message<"guest.v1.ProductPrice"> & {
  /**
   * 価格種別 ID。
   *
   * @generated from field: int64 price_type_id = 1;
   */
  priceTypeId: bigint;

  /**
   * 価格種別名 (例: 一般 / 子供)。
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * 価格区分 (例: 一般 / 小人)。
   *
   * @generated from field: string price_type = 3;
   */
  priceType: string;

  /**
   * 価格 (JPY・整数)。
   *
   * @generated from field: int64 price = 4;
   */
  price: bigint;

  /**
   * 補足 (例: 小学生以下)。
   *
   * @generated from field: string description = 5;
   */
  description: string;
};

/**
 * Describes the message guest.v1.ProductPrice.
 * Use `create(ProductPriceSchema)` to create a new message.
 */
export const ProductPriceSchema: GenMessage<ProductPrice> = /*@__PURE__*/
  messageDesc(file_guest_v1_shop, 4);

/**
 * ShopService はゲスト (案件アクセストークン保持者) 向けの店舗情報参照を提供する。
 * 認証は Cognito を通さず、URL 由来の案件アクセストークンを x-case-token ヘッダで受け取り、
 * Guest 公開 Interceptor がハッシュ照合して案件・テナントを解決する (ADR-011 /
 * ゲストアプリの設計 §4・§5)。トークン不一致・失効は NotFound、期限切れは FailedPrecondition。
 * サービスはトークンで解決した 1 案件のスコープに閉じる (§5.1)。
 *
 * @generated from service guest.v1.ShopService
 */
export const ShopService: GenService<{
  /**
   * GetShopDetail は提案された店舗の詳細情報を返す (ゲストアプリの設計 §5.2・§7)。
   * shop_id が案件の提案範囲 (case_item.proposal の対象店舗) に含まれるかを検証し、
   * 範囲外は存在を秘匿するため NotFound を返す。表示は指定言語を優先し、
   * 無ければ英語 (en) にフォールバックする。
   *
   * @generated from rpc guest.v1.ShopService.GetShopDetail
   */
  getShopDetail: {
    methodKind: "unary";
    input: typeof GetShopDetailRequestSchema;
    output: typeof GetShopDetailResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_guest_v1_shop, 0);

